import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import styles from './LoadingTable.scss';

const LoadingTable = ({ rowsNumber, loadingText }) => {
    const rows = [...Array(rowsNumber).keys()];

    return (
        <div>
            {
                rows.map((index) =>
                    <React.Fragment key={`${index}--`}>
                        <div key={index} className={styles.row}></div>
                    </React.Fragment>
                )
            }
            <div className={styles.gradient} />
            <Chip label={loadingText} className={styles.chip} />
        </div>
    );
};

LoadingTable.propTypes = {
    rowsNumber: PropTypes.number,
    loadingText: PropTypes.string
};

LoadingTable.defaultProps = {
    rowsNumber: 9,
    loadingText: 'Loading'
};

export default LoadingTable;
